import { encodeOpaqueUrlPathSegment } from '../routing/encode-opaque-url-path-segment';
import { toLocationSlug } from './to-location-slug';

/**
 * Percent-encodes a location value for use as a single SRP path segment.
 * Normalizes display strings (e.g. "Helsinki, Finland") and existing slugs
 * (e.g. "Helsinki_Finland", "Jyväskylä_Suomi") via {@link toLocationSlug}, then
 * applies {@link encodeOpaqueUrlPathSegment} so UTF-8 and reserved characters
 * never appear literally in URLs.
 */
export function encodeLocationUrlPathSegment(raw: string | null | undefined): string {
  const slug = toLocationSlug(raw);
  if (!slug) return '';
  return encodeOpaqueUrlPathSegment(slug);
}

/**
 * Like {@link encodeLocationUrlPathSegment} but accepts values that may already
 * be partially percent-encoded in an incoming URL segment.
 */
export function encodeLocationUrlPathSegmentFromMaybeEncoded(raw: string | null | undefined): string {
  if (raw == null || typeof raw !== 'string') return '';
  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    // keep raw when decoding fails
  }
  return encodeLocationUrlPathSegment(decoded);
}
